import { createRoute, redirect } from '@tanstack/react-router'
import { rootRoute } from '@/app/routes/_root'
import { LoginPage } from './pages/LoginPage'
import { PasswordResetPage } from './pages/PasswordResetPage'
import { SsoCallbackPage } from './pages/SsoCallbackPage'

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
  validateSearch: (raw: Record<string, unknown>) => {
    const r = raw['redirect']
    return typeof r === 'string' && r.startsWith('/') ? { redirect: r } : {}
  },
  beforeLoad: ({ context, search }) => {
    if (context.auth.isSignedIn) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: search.redirect ?? '/' })
    }
  },
})

export const passwordResetRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/reset-password',
  component: PasswordResetPage,
  beforeLoad: ({ context }) => {
    if (context.auth.isSignedIn) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/' })
    }
  },
})

// OAuth round-trip: Clerk sends the browser here after GitHub auth so the
// SDK can exchange the code, set the session, then forward to the original
// destination. No layout shell — should be invisible to the user.
export const ssoCallbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/sso-callback',
  component: SsoCallbackPage,
})
